import React, {useEffect, useState} from 'react'
import FailedModal from "../../CustomModal/Failed";
import Loader from "../../../Loader/Loader";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import SuccessModal from "../../CustomModal/Success";
import {toast} from "react-toastify";
import DashboardMenu from "../../layout/dashboardMenu";

const RejectActivity = ({
                             dropdownData,
                             dropdownValue = [],
                             match,
                             activityProposal,
                             checkOpportunity = [],
                             checkCloseOrDropped,
                             history,
                            rejectActivity,
                            rejectActivityDetails=[]
                         }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const islatlng = useLatLng();
    const [isAllow, setIsAllow] = useState(false);
    const [activityTypes, setActivityTypes] = useState([])
    const [isDropped, setIsDropped] = useState('no')
    const [inputList, setInputList] = useState([{
        next_activity_id: '',
        next_activity_date: '',
        lat: '',
        long: '',
        description:'',
        meta_data:{}
    }])
    const [successMessage, setSuccessMessage] = useState('')

    useEffect(() => {
        if (dropdownValue?.opportunity_activity_type !== undefined) {
            setActivityTypes(dropdownValue?.opportunity_activity_type)
        }

    }, [dropdownValue])

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await checkCloseOrDropped(match?.params?.opportunity_id)
            await dropdownData()
            await activityProposal(match?.params?.opportunity_id, match?.params?.activity_id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {
        if (checkOpportunity && checkOpportunity?.id !== undefined && parseInt(match?.params?.type_id) !== 29) {
            window.location.href = "opportunity-list/" + checkOpportunity?.account_id
        }
    }, [checkOpportunity])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    const handleInput = (key, val, metaKey = '', e = '') => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                inputList[0][key][metaKey] = e.target.selectedOptions[0].text
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }


    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (rejectActivityDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setSuccessMessage(rejectActivityDetails?.message)
        } else if (rejectActivityDetails?.status !== undefined && rejectActivityDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
            setSuccessMessage(rejectActivityDetails?.message)
        }
    }, [rejectActivityDetails])


    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        list['id'] = match?.params?.activity_id
        list['account_id'] = match?.params?.account_id
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }


        // list['is_task'] = taskNeedToCreate
        if (match?.params?.lead_id !== undefined) {
            list['lead_id'] = match?.params?.lead_id
        }
        //
        // if(!taskNeedToCreate){
        //     delete  list['task_title']
        //     delete  list['task_description']
        //     delete  list['task_date']
        // }
        setIsLoading(true)
        await rejectActivity(list)
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={successMessage}
                url={`activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={successMessage}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            {/* <div className="d-sm-flex align-items-center justify-content-between mb-4d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-black-100">Activity</h1>
                            </div> */}
                            <form onSubmit={(e) => handleSubmit(e)}>

                                <div className="row">
                                    <div className="col-md-12">
                                        {parseInt(match?.params?.type_id) === 1 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Gate Crashing</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder={`Remark`}
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, e)
                                                                    }} required={isDropped !== 'yes'}>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, e)
                                                                       }}
                                                                       id="validationCustom01"
                                                                       required={isDropped !== 'yes'}
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-3">
                                                                <textarea
                                                                    className="form-control form-control-user"
                                                                    placeholder="Description"
                                                                    onChange={(e) => {
                                                                        handleInput('description', e.target.value,'', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 2 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                            <hr/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required={isDropped !== 'yes'}>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-075 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required={isDropped !== 'yes'}
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-3">
                                                                <textarea
                                                                    className="form-control form-control-user"
                                                                    placeholder="Description"
                                                                    onChange={(e) => {
                                                                        handleInput('description', e.target.value,'', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 3 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-2 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-01 float-field mb-3">
                                                                <textarea
                                                                    className="form-control form-control-user"
                                                                    placeholder="Description"
                                                                    onChange={(e) => {
                                                                        handleInput('description', e.target.value,'', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 4 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value)
                                                                    }} required={isDropped !== 'yes'}>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required={isDropped !== 'yes'}
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-3">
                                                                <textarea
                                                                    className="form-control form-control-user"
                                                                    placeholder="Description"
                                                                    onChange={(e) => {
                                                                        handleInput('description', e.target.value,'', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 5 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required={isDropped !== 'yes'}>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-05 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required={isDropped !== 'yes'}
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder="Description"
                                                                        onChange={(e) => {
                                                                            handleInput('description', e.target.value, '', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 6 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user cus-red"
                                                                        placeholder="Remark*"
                                                                        onChange={(e) => {
                                                                            handleInput('meta_data', e.target.value, 'remark', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-1 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder="Remark"
                                                                        onChange={(e) => {
                                                                            handleInput('description', e.target.value, '', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 7 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-1 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder="Remark"
                                                                        onChange={(e) => {
                                                                            handleInput('description', e.target.value, '', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 14 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-4 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder="Remark"
                                                                        onChange={(e) => {
                                                                            handleInput('meta_data', e.target.value, 'remark', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 12 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-1 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder="Remark"
                                                                        onChange={(e) => {
                                                                            handleInput('description', e.target.value, '', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 8 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-1 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder="Remark"
                                                                        onChange={(e) => {
                                                                            handleInput('description', e.target.value, '', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {parseInt(match?.params?.type_id) === 9 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                        return (
                                                            <>
                                                                {parseInt(val?.id) === parseInt(match?.params?.type_id) &&
                                                                    <h1 className="h3 mb-0 text-black-100"><b>{val?.name}</b></h1>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-4 float-field">
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        handleInput('next_activity_id', e.target.value, "", e)
                                                                    }} required>
                                                                    <option value="">Select Next Activity
                                                                    </option>
                                                                    {activityTypes.length > 0 && activityTypes.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}
                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Activity <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-1 float-field">
                                                                <input type="date"
                                                                       className="form-control form-control-user"
                                                                       placeholder=" "
                                                                       onChange={(e) => {
                                                                           handleInput('next_activity_date', e.target.value, "", e)
                                                                       }}
                                                                       required
                                                                       min={new Date().toISOString().split('T')[0]}
                                                                />
                                                                <label className="large-label float-lb">
                                                                    Date <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mt-1 float-field mb-4">
                                                                    <textarea
                                                                        className="form-control form-control-user"
                                                                        placeholder="Remark"
                                                                        onChange={(e) => {
                                                                            handleInput('description', e.target.value, '', e)
                                                                        }}
                                                                        required
                                                                        rows="4" cols="50"
                                                                    />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        {parseInt(match?.params?.type_id) === 29 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>Post Closure</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mt-1 float-field">
                                                                <textarea
                                                                    className="form-control form-control-user cus-red"
                                                                    placeholder="Remark*"
                                                                    onChange={(e) => {
                                                                        handleInput('meta_data', e.target.value, 'remark', e)
                                                                    }}
                                                                    required
                                                                    rows="4" cols="50"
                                                                />
                                                                <label className="large-label float-lb">
                                                                    {/*Remark*/}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-12 mt-4 d-flex" >
                                    <button className="btn btn-primary btn-user btn-block submit-btn" style={{backgroundColor:"#d94d40"}}>
                                        Reject
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default RejectActivity